import axios from '../../../axiosConfig';

export async function getAssets(config = {}, requestBody) {
    return await axios.post(`/v1/asset/all`, requestBody, config);
}

export async function getAssetById(id, requestBody, config = {}) {
    return await axios.post(`/v1/asset/${id}`, requestBody, config);
}

export async function getRateDetailsByAssetId(id, requestBody, config = {}) {
    return await axios.post(`/v1/asset/${id}/rate-details`, requestBody, config);
}

export async function getNextInventoryNumber(config = {}) {
    return await axios.get(`/v1/asset/next-inventory-number`, config);
}

export async function createAsset(config = {}, data) {
    return await axios.post(`/v1/asset`, data, config);
}

export async function updateAsset(config = {}, data) {
    return await axios.put(`/v1/asset/${data.id}`, data, config)
}

export async function calculateCommissioningDate(config = {}) {
    return await axios.get(`/v1/asset/commissioning-date`, config);
}

export async function createDepreciationRate(data, config = {}) {
    return await axios.post(`/v1/asset`, data, config);
}

export async function getEmployeeHistory(id, config = {}) {
    return await axios.get(`/v1/asset/${id}/employee-history`, config);
}

export async function getLocationHistory(id, config = {}) {
    return await axios.get(`/v1/asset/${id}/location-history`, config);
}

export async function changeActiveStatus(config = {}, id) {
    return await axios.put(`/v1/asset/${id}/active-status`, {}, config);
}

export async function exportAssetExcelReport(config = {}, requestBody) {
    return await axios.post(`/v1/reports/asset-excel`, requestBody, config);
}

export async function getTotalAmounts(config = {}, requestBody) {
    return await axios.post(`/v1/asset/totals`, requestBody, config);
}

export function handleContentDisposition(response) {
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const contentDisposition = response.headers["content-disposition"];
    let fileName = contentDisposition.split("filename=")[1];
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
}

const functions = {
    getAssets,
    getAssetById,
    getNextInventoryNumber,
    createAsset,
    updateAsset,
    calculateCommissioningDate,
    createDepreciationRate,
    getEmployeeHistory,
    getLocationHistory,
    changeActiveStatus,
    exportAssetExcelReport,
    handleContentDisposition
}
export default functions
